var ImageSlider   = require("app/ui/ImageSlider"),
    Layout        = require("./ImageSliderGraphicLayout"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("./ImageSliderGraphic.less");

module.exports = kind(/** @lends  app.ui.HeaderGraphic.ImageSliderGraphic.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HeaderGraphic.ImageSliderGraphic",

    /**
     * @private
     */
    classes: "app-ui-header-graphic-image-slider-graphic",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * Layout metrics tell us how to scale the slider.
     *
     * @type {Object}
     * @readonly
     * @public
     */
    layoutMetrics: null,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:        "slider",
        kind:        ImageSlider,
        classes:     "app-ui-header-graphic-image-slider-graphic__slider",
        showButtons: false
    }, {
        name:    "leftGradient",
        classes: "app-ui-header-graphic-image-slider-graphic__left-gradient"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state = this.state || {};

        this.$.leftGradient.set("showing", get(state, "data.show_meta_text", false));
        this.$.slider.set("data", get(state, "data.meta.slides", []));
    }

});
